import React, { Component } from 'react';
import { Alert, Form, Button } from 'react-bootstrap';
import ReCAPTCHA from 'react-google-recaptcha';
import { FaArrowRight } from 'react-icons/fa';
import InputMask from 'react-input-mask';
import MetaGroup from '../../components/meta-group';
import Faq from '../../components/faq';
import { submitDemoEmail } from '../../actions/forms';
import { validateEmail, validatePhone } from '../../helpers/validation';

class ScheduleDemo extends Component {
  state = {
    first: '',
    last: '',
    company: '',
    email: '',
    phone: '',
    marketingOptIn: false,
    sendSuccess: false,
    captchaGood: false,
  }

  onChangeInput = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  }

  onChangeMarketingOptIn = (event) => {
    this.setState({ marketingOptIn: event.target.checked });
  }

  onChangeCaptcha = () => {
    this.setState({ captchaGood: true });
  }

  async handleSubmit() {
    this.setState({ sendSuccess: true });
    const { email, first, last, company, phone, marketingOptIn } = this.state;
    await submitDemoEmail({ userEmail: email, first, last, company, phone, marketingOptIn });
  }

  render() {
    const { first, last, company, email, phone, marketingOptIn, captchaGood, sendSuccess } = this.state;
    let disabled = true;
    if (validateEmail(email) && validatePhone(phone) && first && last && company && marketingOptIn && captchaGood) {
      disabled = false;
    }
    return (
      <div>
        <MetaGroup
          title="Schedule a demo - Rossware Software, LLC."
          metaDescription="Reach out to us, we're here to help you. You can contact us by phone, email, or live chat."
          ogImage="%PUBLIC_URL%/logo512.png"
          canonical="contact"
        />
        <section>
          <div className="container grid-2-col md-gap">
            <div>
              <h1 className="mb-3">Ready to see more of Rossware?</h1>
              <p className="lead">Schedule a demo with one of our experts to find out how Rossware can improve the way you do business.</p>
            </div>
            <div>
              <div className="demo-form">
                <h2 className="h4">Sign up for a demo</h2>
                {sendSuccess &&
                  <Alert variant="success" className="py-4">
                    <Alert.Heading>Thanks for reaching out to us!</Alert.Heading>
                    <hr />
                    <div>Someone from our team will contact you shortly to schedule your demo.</div>
                  </Alert>
                }
                {!sendSuccess &&
                  <Form className="text-left">
                    <div className="form-group grid-2-col">
                      <div>
                        <label>First name <code>*</code></label>
                        <Form.Control type="text" name="first" value={first} onChange={this.onChangeInput} placeholder="e.g., John" />
                      </div>
                      <div>
                        <label>Last name <code>*</code></label>
                        <Form.Control type="text" name="last" value={last} onChange={this.onChangeInput} placeholder="e.g., Smith" />
                      </div>
                    </div>
                    <div className="form-group">
                      <label>Company name <code>*</code></label>
                      <Form.Control type="text" name="company" value={company} onChange={this.onChangeInput} placeholder="Your company" />
                    </div>
                    <div className="form-group">
                      <label>Email <code>*</code></label>
                      <Form.Control type="email" name="email" value={email} onChange={this.onChangeInput} placeholder="you@company.com" />
                    </div>
                    <div className="form-group position-relative">
                      <label>Phone <code>*</code></label>
                      <Form.Control as={InputMask} mask="999-999-9999" type="tel" name="phone" className="optional" value={phone} onChange={this.onChangeInput} placeholder="000-000-0000" />
                    </div>
                    <div className="form-group form-check">
                      <Form.Check
                        type="checkbox"
                        id="marketingOptIn"
                        name="marketingOptIn"
                        label="I agree to receive marketing messages and emails from Rossware."
                        checked={marketingOptIn}
                        onChange={this.onChangeMarketingOptIn}
                        required
                      />
                    </div>
                    <div className="float-left mb-3">
                      <ReCAPTCHA
                        size="normal"
                        sitekey="6LcjVFsUAAAAAAT0mrnR8ONYHMxXbX5a37OGH8LU"
                        onChange={this.onChangeCaptcha}
                      />
                    </div>
                    <Button disabled={disabled} className="btn-block btn-icon-right" onClick={() => this.handleSubmit()}>Send <FaArrowRight /></Button>
                  </Form>
                }
              </div>
            </div>
          </div>
        </section>
        <Faq />
      </div>
    );
  }
}

export default ScheduleDemo;
